<script src="//res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<template>
  <div class="coin-container">
    <!-- 虚拟币余额 -->
    <div class="balance">
      <img class="img" src="~@/assets/img/my-fish.png" alt="" />
      <div class="balance-info">
        <p class="total">{{ coin.tmpAmount + coin.amount }}</p>
        <div class="detail">
          <p class="tmp-amount">{{ coin.tmpAmount | numFilter }} 限时小鱼干</p>
          <p class="amount">{{ coin.amount | numFilter }} 永久小鱼干</p>
        </div>
      </div>
    </div>
    <!-- 虚拟币描述 -->
    <div class="desc">「永久小鱼干列表」</div>
    <!-- 虚拟币商品列表 -->
    <div class="item-list">
      <div class="item" v-for="(coinItem, index) in coinItemList" :key="index" @click="buyCoin(coinItem)">
        <!-- 虚拟币数量 -->
        <div class="item-amount">
          <img class="img" src="~@/assets/img/fish.png" alt="" />
          <p class="amount">{{ coinItem.name }}</p>
          <p class="discount" v-if="(coinItem.price / coinItem.originPrice) * 10 < 10">
            限时{{ ((coinItem.price / coinItem.originPrice) * 10) | numFilter }}折
          </p>
        </div>
        <!-- 虚拟币价格 -->
        <div class="item-price">
          <p class="price">¥{{ coinItem.price / 100 }}</p>
          <p class="origin-price">¥{{ coinItem.originPrice / 100 }}</p>
        </div>
      </div>
    </div>

     <!-- 跳转小程序的弹窗-->
     <div class="modal-bg" v-show="isShow">
            <wx-open-launch-weapp
              username="gh_8a283352682b"
              path="pages/home/home.html"
            >
              <script type="text/wxtag-template">
                <style>
                  .popup-container{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: max-content;
                    padding: 20px 10px;
                    background:white;
                    border-radius: 15px;
                  }

                  .popup-title{
                    font-weight: 700;
                    font-size: 20px;
                  }

                  .popup-desc{
                    color: #585b66;
                    font-size: 15px;
                    margin-top: 15px;
                    margin-bottom: 15px;
                  }

                  .popup-jump-ma{
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: 100%;
                      color: white;
                      background: linear-gradient(274.73deg, #6a5ec8 0%, #9675f3 100%);
                      box-shadow: 0px 6px 16px rgba(106, 94, 200, 0.2);
                      border-radius: 200px;
                      font-weight: 500;
                      font-size: 15px;
                      height: 30px;
                  }
                  </style>
                <div class="popup-container">  
                <div class="popup-title">未注册小程序</div>
                <div class="popup-desc">请点击【确认】跳转到小程序</div>
                <div class="popup-jump-ma" @launch>确认</div>  
              </script>
            </wx-open-launch-weapp>
     </div>

</div>

  
</template>



<script>
import wxApi from "@/utils/wxAuth";
import { TERM_TYPE_H5 } from '@/config/constant'
export default {
  name: "coinInfo",
  data() {
    return {
      // coin 用户虚拟币余额信息
      coin: {
        tmpAmount: 0,
        amount: 0,
      },
      // coinItemList 虚拟币商品信息
      coinItemList: {},
      // mid 用户对外的ID
      mid: "",
      // item 预支付商品信息
      item: {},  

      isShow:false
    };
  },
  filters: {
    numFilter(value) {
      // 截取当前数据到小数点后1位
      let realVal = parseFloat(value).toFixed(1);
      return realVal;
    },
  },
  methods: {
     /* 
        getSignature 购买虚拟币接口 [HTTP 请求]
        GET
     */
    async initConfig() {
      console.log("getSignature,url=", window.location.href);
       // 先获取签名信息
       await this.$helloHttp(
          `/wechat/signature`,
          {url:window.location.href},
          "post"
        )
        // 拿到签名信息后,去初始化config
        .then(res => {
          if (res.code === 0) {
              // wxApi.config(res.data)
              let { appId, timestamp, nonceStr, signature } = res.data
              console.log("getSignature,appId={},timestamp={},nonceStr={},signature={}", 
              appId,timestamp,nonceStr,signature);

              wx.config({
                appId, // 必填，公众号的唯一标识
                timestamp, // 必填，生成签名的时间戳
                nonceStr, // 必填，生成签名的随机串
                signature, // 必填，签名
                jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateTimelineShareData','updateAppMessageShareData','wx-open-launch-weapp','chooseImage', 'previewImage'], // 必填，需要使用的JS接口列表
                openTagList: ["wx-open-launch-weapp"] // 跳转小程序时必填
              })

              //console.error('ready before, wx.config={}', wx.config)
              wx.ready(function() {
                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
                console.log("wx ready");
              });

              wx.error(res => {
                console.error('wxerr: ', res)
              })
          }
        }, err => {
        console.log(err)
      })

        // 小程序弹窗
        var btn = document.getElementById('launch-btn');
        btn.addEventListener('launch', function (e) {
          console.log('success');
        });
        btn.addEventListener('error', function (e) {
          console.log('fail', e.detail);
        });
    },
    /* 
        buyCoin 购买虚拟币接口 [HTTP 请求]
        URL: /preOrder/{itemId}/{tradeType}/{termType} GET
    */
    async buyCoin(coinItem) {
      console.log("buyCoin,coinItem=", coinItem);
      if (coinItem) {
        const res = await this.$helloHttp(
          `/wxpay/preOrder/${coinItem.itemId}/JSAPI/${TERM_TYPE_H5}`,
          {},
          "get",
          {
            Authorization: `Bearer ${window.localStorage.getItem("token")}`,
          }
        );
        // 接口失败
        if (!res.success) {
          this.$toast("接口异常！")
          return;
        }
        // 接口成功
        this.item = res.data;
        if (typeof window.WeixinJSBridge === "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              this.onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
          }
        } else {
          this.onBridgeReady();
        }
      }
    },
    onBridgeReady() {
      const { appId, timeStamp, nonceStr, paySign, signType, prepayId } =
        this.item;
      if (typeof window !== "undefined") {
        window.WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId, // 公众号名称，由商户传入
            timeStamp, // 时间戳，自1970年以来的秒数
            nonceStr, // 随机串
            package: `prepay_id=${prepayId}`,
            signType, // 微信签名方式：
            paySign, // 微信签名
          },
          async (res) => {
            if (res.err_msg === "get_brand_wcpay_request:ok") {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              this.$toast("支付成功！");
              window.location.reload();
            }
          }
        );
      }
    },

    /* 
        getToken 拿到H5的登录态接口 [HTTP 请求] 
        用code换来token. getToken接口内部已做身份幂等校验
        URL: /coin/getToken GET
    */
    async getToken() {
      console.log("getToken,code=", this.$route.query.code);
      const res = await this.$helloHttp(
        `/members/getToken`,
        { code: this.$route.query.code },
        "get"
      );
      console.log("getToken,res=", res);

      // 接口获取成功
      if (res.success) {
        console.log("getToken,success");
        console.log("needLoginMa = {}",res.data.needLoginMa);
        // 判断是否要拉起来注册小程序
        if (res.data.needLoginMa) {
          this.isShow=true
          // 初始化配置
          this.initConfig()
          return
        }
        // 写入token 验证信息
        window.localStorage.setItem("token", res.data.token);

        // 写入 mid 用户外部ID
        window.localStorage.setItem("mid", res.data.mid);
        this.mid = window.localStorage.getItem("mid");

        // 获取虚拟币余额
        this.getCoin();

        // 获取虚拟币商品列表
        this.getCoinItemList();
      }
      // 接口获取失败
      else {
        this.$toast('获取token失败')
      }
    },
    /* 
        getCoin 获取用户虚拟币余额接口 [HTTP 请求]
        URL: /coin/getCoin GET
    */
    async getCoin() {
      let res;
      console.log("getCoin,token=", window.localStorage.getItem("token"));
      // 发起请求
      if (window.localStorage.getItem("token") === null) {
        res = await this.$helloHttp(`/coins/self`, {}, "get");
      } else {
        res = await this.$helloHttp(`/coins/self`, {}, "get", {
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        });
      }
      console.log("getCoin,res=", res);
      // 接口获取成功
      if (res.success) {
        console.log("getCoin success");
        this.coin = res.data;
      }
      // 接口获取失败
      else {
        // this.$toast('获取虚拟币余额失败')
        this.isShow=true
        // 初始化配置
        this.initConfig()
        return
      }
    },

    /* 
        getCoinItemList 用户查看虚拟币商品列表接口 [HTTP 请求]
        URL: /coin/item/list GET
    */
    async getCoinItemList() {
      let res;
      console.log(
        "getCoinItemList,token=",
        window.localStorage.getItem("token")
      );
      // 发起请求
      if (window.localStorage.getItem("token") === null) {
        res = await this.$helloHttp(`/items/coins`, {}, "get");
      } else {
        res = await this.$helloHttp(`/items/coins`, {}, "get", {
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        });
      }
      //console.log("getCoinItemList,res=", res);
      // 接口获取成功
      if (res.success) {
        console.log("getCoinItemList success");
        this.coinItemList = res.data.coinItemList;
      }
      // 接口获取失败
      else {
        this.$toast('获取虚拟币商品列表失败')
      }
    },
  },   
  mounted() {
    // 当能从本地缓存拿到token时, 则开始正常进行接口的数据获取
    console.log("mounted, localStorage=", window.localStorage);
    console.log("mounted, token=", window.localStorage.getItem("token"));
    console.log("mounted, code=", this.$route.query.code);
    if (window.localStorage.getItem("token")) {
      this.mid = window.localStorage.getItem("mid");
      this.getCoin();
      this.getCoinItemList();
    } else if (this.$route.query.code) {
      this.getToken();
    } else {
      // 当使用localhost域名调试的时候，先访问pre-www.hellobuluo.com/coin-1.html从localstorage里面获取token
      // 在访问localhost，将token值set进去
      if (!window.location.href.includes("localhost")) {
        wxApi
          .init({
            appid: process.env.VUE_APP_APP_ID, // 正式测试号
            redirectUri: window.location.href,
          })
          .author(false);
      }
    }
  }
  }
</script>

<style lang="scss" scoped>
@import "@/assets/scss/constant.scss";
.coin-container {
  display: flex;
  flex-direction: column;
  color: #000000;
}
.balance {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: linear-gradient(274.73deg, #6a5ec8 0%, #9675f3 100%);
  color: white;
  padding: 50px 20px;
}
.balance-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.desc {
  background: #eeeff0;
  padding: 20px 0;
  color:#747474;
}
.item-list {
  display: flex;
  flex-direction: column;
}
.item-amount .img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}
.item-amount {
  display: flex;
  align-items: center;
}
.item-price {
  display: flex;
  align-items: center;
}

.price {
  margin-right: 5px;
}
.balance .img {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}
.balance-info {
  align-items: flex-start;
  width: 100%;
}
.total {
  font-size: 40px;
}
.detail {
  display: flex;
  margin-top: 5px;
  justify-content: space-between;
  width: inherit;
}
.discount{
    padding: 0.13333rem;
    color: #fff;
    background: linear-gradient(116.84deg, #FFAA68 11.7%, #F98A39 97.77%);
    border-radius: 100px;
    padding: 6px 16px;
}
.amount {
  margin-right: 10px;
}
.origin-price {
  text-decoration: line-through;
  color:#747474;
}
.instruction {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: solid 1px #e9eaeb;
  padding: 40px 20px;
}

.openweapp{
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.modal-bg{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  background-color: rgba(0,0,0,0.7);
}

.modal-bg-wrap{
    color: white;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(274.73deg, #6a5ec8 0%, #9675f3 100%);
    box-shadow: 0px 6px 16px rgba(106, 94, 200, 0.2);
    font-weight: 500;
    font-size: 40px;
    border-radius: 20px;
}

.item-list{
  color:#2a2b33
}

.popup-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: max-content;
  padding: 10px;
}

.popup-title{
  font-weight: 700;
  font-size: 40px;
}

.popup-desc{
  color: #585b66;
  font-size: 30px;
}

.popup-jump-ma{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: white;
    margin-top: 20px;
    background: linear-gradient(274.73deg, #6a5ec8 0%, #9675f3 100%);
    box-shadow: 0px 6px 16px rgba(106, 94, 200, 0.2);
    border-radius: 200px;
    font-weight: 500;
    font-size: 30px;
    height: 70px;
}
</style>

